import { zodResolver } from '@hookform/resolvers/zod';
import { useMutation } from '@tanstack/react-query';
import { App, Button, Form, Input, Result } from 'antd';
import { Controller, useForm } from 'react-hook-form';
import { authApi } from '../auth.api';
import { forgotPasswordSchema, type ForgotPasswordForm } from '../auth.schemas';

export function ForgotPasswordPage() {
  const { message } = App.useApp();
  const form = useForm<ForgotPasswordForm>({
    resolver: zodResolver(forgotPasswordSchema),
    defaultValues: { email: '' },
  });

  const mutation = useMutation({
    mutationFn: authApi.forgotPassword,
    onError: (error) => message.error(error instanceof Error ? error.message : 'Request failed'),
  });

  if (mutation.isSuccess) {
    return (
      <Result
        status="success"
        title="Check your inbox"
        subTitle="If an account exists for that email, we've sent a password reset link."
      />
    );
  }

  return (
    <Form layout="vertical" onFinish={form.handleSubmit((v) => mutation.mutate(v))}>
      <Controller
        control={form.control}
        name="email"
        render={({ field, fieldState }) => (
          <Form.Item
            label="Email"
            validateStatus={fieldState.error ? 'error' : ''}
            help={fieldState.error?.message}
          >
            <Input {...field} type="email" autoComplete="email" placeholder="you@example.com" />
          </Form.Item>
        )}
      />
      <Button type="primary" htmlType="submit" block loading={mutation.isPending}>
        Send reset link
      </Button>
    </Form>
  );
}
